import type { ComponentEntry } from '../../core/common-types'

const entry: ComponentEntry = {
	componentType: 'RemoteRefDeadComp',
	loadComponent: () => import('./RemoteRefDeadComp.js' /* webpackChunkName: "RemoteRefDeadComp" */),
}

export default entry
